/* eslint-disable */
export default {
  _title: 'title',
  _menu_dialog: 'menu_dialog',
}